import { Button } from '../../catalyst/button';

interface EmptyQueuePanelProps {
  /** Total flagged for curation. 0 means the queue was empty from the start. */
  total: number;
  onRefresh: () => void;
}

/**
 * Neutral empty state shown when nothing was reviewed this session — either the
 * queue was empty from the start (`total === 0`) or every loaded item was skipped
 * (`total > 0`). Never offers retrain actions or implies the queue was completed.
 */
export function EmptyQueuePanel({ total, onRefresh }: EmptyQueuePanelProps) {
  const heading = total === 0 ? 'Nothing to review' : 'Nothing left in this batch';
  const body =
    total === 0
      ? 'No pages are currently flagged for curation.'
      : "Skipped items aren't saved and will reappear on refresh.";

  return (
    <div className="bg-white dark:bg-zinc-800 shadow dark:shadow-zinc-950/30 rounded-lg dark:border dark:border-zinc-700 p-8 text-center space-y-4 max-w-lg mx-auto mt-12">
      <p className="text-lg font-semibold text-gray-900 dark:text-zinc-100">{heading}</p>
      <p className="text-sm text-gray-500 dark:text-zinc-400">{body}</p>
      <Button outline onClick={onRefresh}>
        Refresh
      </Button>
    </div>
  );
}
